module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/wind-7febc5e959619166d062e6649aafe912.svg";